/* eslint-disable react/prop-types */
import Input from 'components/Form/Input'
import SearchIcon from 'components/icons/SearchIcon'
import React from 'react'
import styled from 'styled-components'

const StyleInput = styled(Input)`
  .ant-input {
    font-weight: 400;
    font-size: 16px;
    line-height: 24;
    margin-left: 10px;
  }
  box-shadow: 0px 4px 5px -3px rgba(0, 0, 0, 0.1);
  border-radius: 0;
  border: ${props => props?.borderLess && 'none'};
`

const SearchInput = ({
  searchValue,
  setSearchValue,
  height = '38px',
  width = '240px',
  placeholder = 'Search',
  allowClear,
  suffix = <SearchIcon />,
  prefix = <SearchIcon />,
  bordered = true,
  borderLess = false,
  iconPosition = 'suffix',
  ...rest
}) => {
  const onSearchChange = e => {
    setSearchValue(e.target.value)
  }
  return (
      <StyleInput
        {...rest}
        width={width}
        height={height}
        placeholder={placeholder}
        suffix={iconPosition == 'suffix' && suffix}
        prefix={iconPosition == 'prefix' && prefix}
        value={searchValue}
        onChange={onSearchChange}
        allowClear={allowClear}
        bordered={bordered}
        borderLess={borderLess}
      />
  )
}
export default SearchInput
